import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "./notificationmodal.css";
import { Component } from 'react';
import UpdateSummary from './UpdateSummary/UpdateSummary';



export class NotificationModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modulesFetching: false,
            queryListFetching: false,
            moduleList: {},
            moduleId: null,
            srId: null,
            queryList: [],
            serviceRequestId: null,
            currentRequest: {},
            currentClientResponse: {},
            clientResponseFetching: false,
            currentReleaseId: this.props.currentReleaseId,
            currentQueryTitle: '',
            releaseAssociatedSrListFetching: false,
            completeReleaseFetching: false,
            currentModuleId: null







        }
    }



    render() {
        return (
            <div className={this.props.releaseNotificationModalOpen ? 'modal show' : 'modal hide'} id="modalContainer" >
                <div className="modal-dialog genericRequestContainer workspace-current-modal-mode notification-mobile-mode">
                    <div className='modal-content generic-CheckContainer workspace-current-modal-mode notification-mobile-mode' ref={this.props.modalRef} style={{marginTop:'0'}}>
                        <div className='admin-dashboard-container'>
                            <span className='feasibility-heading' style={{ borderBottom: '1px solid #C1CDD7', padding: '0px 0px 16px 32px' }}>
                                <p className='vm_custom_title1' >{this.props.currentRelease.title + " - " + this.props.currentRelease.sprintId}
                                </p>
                                <FontAwesomeIcon icon={["fas", "times"]} size='sm' style={{ height: '18px', width: '18px', cursor: 'pointer' }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        this.props.onClose();
                                    }}
                                />

                            </span>


                            <UpdateSummary
                                currentTeam={this.props.currentTeam}
                                releaseID={this.props.releaseID}
                                currentRelease={this.props.currentRelease}
                                onClose={this.props.onClose}
                            />

                        </div>


                    </div >
                </div>

            </div>
        )
    }
}

export default NotificationModal
